module.exports = __webpack_public_path__ + "img/组 4.5cd8c3b5.webp";